import React from 'react';

import {getCommandKey, keyEventSwitcher, KeyModifiers} from 'common/util/keyboard';

type Callback = (ev?: KeyboardEvent) => void;
export function useUndoRedoKeyCommands(undoCallback: Callback, redoCallback: Callback) {
  const operatingSystemKeySwitcher = React.useCallback((ev: KeyboardEvent) => {
    const commandKey = getCommandKey();
    return keyEventSwitcher(
      {
        // undo
        [`${commandKey} + KeyZ`]: (keyboardEvent?: KeyboardEvent) => undoCallback(keyboardEvent),

        // redo
        [`${commandKey} + ${KeyModifiers.Shift} + KeyZ`]: (keyboardEvent?: KeyboardEvent) =>
          redoCallback(keyboardEvent),
      },
      {stopPropagation: true},
    )(ev);
  }, []);

  React.useEffect(() => {
    document.addEventListener(`keydown`, operatingSystemKeySwitcher);
    return () => {
      document.removeEventListener(`keydown`, operatingSystemKeySwitcher);
    };
  }, []);
}
